import { combineReducers } from 'redux';
import { laborReducers as labor } from '../../../../app/population/components/labor_tab/redux';
import contract from '../../../../app/population/components/contract_tab/redux';

export default combineReducers({
  labor,
  contract,
});
